import { render, staticRenderFns } from "./iconDetailSubAsset.vue?vue&type=template&id=7b401f1c&scoped=true&"
import script from "./iconDetailSubAsset.vue?vue&type=script&lang=js&"
export * from "./iconDetailSubAsset.vue?vue&type=script&lang=js&"
import style0 from "./iconDetailSubAsset.vue?vue&type=style&index=0&id=7b401f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b401f1c",
  null
  
)

export default component.exports